import {createAction} from "@reduxjs/toolkit";
import {DONE, FAIL, FETCH, MATERIALS_GAME, MATERIALS_GAME_CATEGORIES, MATERIALS_GAMES, MATERIALS, MATERIALS_CARDS, MATERIALS_CARD, TALES, INFOGRAPHICS, MATERIALS_TREE, MATERIALS_DETAIL, KINDERGARTENS_LIST, CHILDRENS, MAIN_VIDEO_LIST, CONTENT_BY_LESSON, EXPORT_PDF, SENSORY_VIDEO_LIST, EXPORT_RESULTS_PDF, INFOGRAPHICS_BY_CODE, ARTICLE_BY_ID, DELETE_CHILD, PSYCHO_CARDS_LIST, UPDATE_PROFILE, ADD_CHILD, UPDATE_CHILD, CARDS_THEME_LIST, EVALUATE, RESET, TEST_RESULTS, REGIONS_LIST, DISTRICTS_LIST, CITIES_LIST, LIST_REQUEST, CREATE_APPLICATION, SET_LIKE, CONTENT_BY_CATEGORY, FETCH_MARATHON_WEEKS, FETCH_MARATHON_DAYS, FETCH_MARATHON_TASKS, FETCH_MARATHON_TASK, SAVE_DIARY, FETCH_DIARY, FETCH_DIARY_TABLE, TASK_COMPLETE, SET, DIAGNOSTIC_RESULT, SELECTED_CHILD_ID, TASK_COMPLETED_LOCAL} from "../../constants"

export const fetchGameCategoriesAction = createAction<any>(MATERIALS_GAME_CATEGORIES + FETCH)
export const fetchGameCategoriesActionDone = createAction<any>(MATERIALS_GAME_CATEGORIES + FETCH + DONE)
export const fetchGameCategoriesActionFail = createAction<any>(MATERIALS_GAME_CATEGORIES + FETCH + FAIL)

export const fetchGamesListAction = createAction<any>(MATERIALS_GAMES + FETCH)
export const fetchGamesListActionDone = createAction<any>(MATERIALS_GAMES + FETCH + DONE)
export const fetchGamesListActionFail = createAction<any>(MATERIALS_GAMES + FETCH + FAIL)

export const fetchCardsListAction = createAction<any>(MATERIALS_CARDS + FETCH)
export const fetchCardsListActionDone = createAction<any>(MATERIALS_CARDS + FETCH + DONE)
export const fetchCardsListActionFail = createAction<any>(MATERIALS_CARDS + FETCH + FAIL)

export const fetchTalesListAction = createAction<any>(TALES + FETCH)
export const fetchTalesListActionDone = createAction<any>(TALES + FETCH + DONE)
export const fetchTalesListActionFail = createAction<any>(TALES + FETCH + FAIL)

export const fetchOneCardAction = createAction<any>(MATERIALS_CARD + FETCH)
export const fetchOneCardActionDone = createAction<any>(MATERIALS_CARD + FETCH + DONE)
export const fetchOneCardActionFail = createAction<any>(MATERIALS_CARD + FETCH + FAIL)

export const fetchOneGameAction = createAction<any>(MATERIALS_GAME + FETCH)
export const fetchOneGameActionDone = createAction<any>(MATERIALS_GAME + FETCH + DONE)
export const fetchOneGameActionFail = createAction<any>(MATERIALS_GAME + FETCH + FAIL)

export const fetchMaterialsAction = createAction<any>(MATERIALS + FETCH)
export const fetchMaterialsActionDone = createAction<any>(MATERIALS + FETCH + DONE)
export const fetchMaterialsActionFail = createAction<undefined>(MATERIALS + FETCH + FAIL)

export const fetchInfographicsAction = createAction<any>(INFOGRAPHICS + FETCH)
export const fetchInfographicsActionDone = createAction<any>(INFOGRAPHICS + FETCH + DONE)
export const fetchInfographicsActionFail = createAction<undefined>(INFOGRAPHICS + FETCH + FAIL)

export const fetchMaterialsTreeAction = createAction<any>(MATERIALS_TREE + FETCH)
export const fetchMaterialsTreeDone = createAction<any>(MATERIALS_TREE + FETCH + DONE)
export const fetchMaterialsTreeFail = createAction<any>(MATERIALS_TREE + FETCH + FAIL)

export const fetchMaterialsDetailAction = createAction<any>(MATERIALS_DETAIL + FETCH);
export const fetchMaterialsDetailDone = createAction<any>(MATERIALS_DETAIL + FETCH + DONE);
export const fetchMaterialsDetailFail = createAction<any>(MATERIALS_DETAIL + FETCH + FAIL);

export const fetchKindergartensListAction = createAction<any>(KINDERGARTENS_LIST + FETCH)
export const fetchKindergartensListDone = createAction<any>(KINDERGARTENS_LIST + FETCH + DONE)
export const fetchKindergartensListFail = createAction<any>(KINDERGARTENS_LIST + FETCH + FAIL)

export const fetchChildrensAction = createAction<any>(CHILDRENS + FETCH)
export const fetchChildrensDone = createAction<any>(CHILDRENS + FETCH + DONE)
export const fetchChildrensFail = createAction<any>(CHILDRENS + FETCH + FAIL)

export const fetchMainVideoListAction = createAction<any>(MAIN_VIDEO_LIST + FETCH)
export const fetchMainVideoListDone = createAction<any>(MAIN_VIDEO_LIST + FETCH + DONE)
export const fetchMainVideoListFail = createAction<any>(MAIN_VIDEO_LIST + FETCH + FAIL)

export const fetchContentByLessonAction = createAction<any>(CONTENT_BY_LESSON + FETCH)
export const fetchContentByLessonDone = createAction<any>(CONTENT_BY_LESSON + FETCH + DONE)
export const fetchContentByLessonFail = createAction<any>(CONTENT_BY_LESSON + FETCH + FAIL)

export const fetchExportPDFAction = createAction<any>(EXPORT_PDF + FETCH)
export const fetchExportPDFDone = createAction<any>(EXPORT_PDF + FETCH + DONE)
export const fetchExportPDFFail = createAction<any>(EXPORT_PDF + FETCH + FAIL)

export const fetchSensoryVideoListAction = createAction<any>(SENSORY_VIDEO_LIST + FETCH)
export const fetchSensoryVideoListDone = createAction<any>(SENSORY_VIDEO_LIST + FETCH + DONE)
export const fetchSensoryVideoListFail = createAction<any>(SENSORY_VIDEO_LIST + FETCH + FAIL)

export const fetchExportResultsPDFAction = createAction<any>(EXPORT_RESULTS_PDF + FETCH)
export const fetchExportResultsPDFDone = createAction<any>(EXPORT_RESULTS_PDF + FETCH + DONE)
export const fetchExportResultsPDFFail = createAction<any>(EXPORT_RESULTS_PDF + FETCH + FAIL)

export const fetchInfographicsByCodeAction = createAction<any>(INFOGRAPHICS_BY_CODE + FETCH)
export const fetchInfographicsByCodeDone = createAction<any>(INFOGRAPHICS_BY_CODE + FETCH + DONE)
export const fetchInfographicsByCodeFail = createAction<any>(INFOGRAPHICS_BY_CODE + FETCH + FAIL)

export const fetchArticleByIdAction = createAction<any>(ARTICLE_BY_ID + FETCH)
export const fetchArticleByIdDone = createAction<any>(ARTICLE_BY_ID + FETCH + DONE)
export const fetchArticleByIdFail = createAction<any>(ARTICLE_BY_ID + FETCH + FAIL)

export const fetchDeleteChildAction = createAction<any>(DELETE_CHILD + FETCH)
export const fetchDeleteChildDone = createAction<any>(DELETE_CHILD + FETCH + DONE)
export const fetchDeleteChildFail = createAction<any>(DELETE_CHILD + FETCH + FAIL)

export const fetchPsychoCardsListAction = createAction<any>(PSYCHO_CARDS_LIST + FETCH)
export const fetchPsychoCardsListDone = createAction<any>(PSYCHO_CARDS_LIST + FETCH + DONE)
export const fetchPsychoCardsListFail = createAction<any>(PSYCHO_CARDS_LIST + FETCH + FAIL)

export const fetchUpdateProfileAction = createAction<any>(UPDATE_PROFILE + FETCH)
export const fetchUpdateProfileDone = createAction<any>(UPDATE_PROFILE + FETCH + DONE)
export const fetchUpdateProfileFail = createAction<any>(UPDATE_PROFILE + FETCH + FAIL)

export const fetchAddChildAction = createAction<any>(ADD_CHILD + FETCH)
export const fetchAddChildDone = createAction<any>(ADD_CHILD + FETCH + DONE)
export const fetchAddChildFail = createAction<any>(ADD_CHILD + FETCH + FAIL)

export const fetchUpdateChildAction = createAction<any>(UPDATE_CHILD + FETCH)
export const fetchUpdateChildDone = createAction<any>(UPDATE_CHILD + FETCH + DONE)
export const fetchUpdateChildFail = createAction<any>(UPDATE_CHILD + FETCH + FAIL)

export const fetchCardsThemeListAction = createAction<any>(CARDS_THEME_LIST + FETCH)
export const fetchCardsThemeListDone = createAction<any>(CARDS_THEME_LIST + FETCH + DONE)
export const fetchCardsThemeListFail = createAction<any>(CARDS_THEME_LIST + FETCH + FAIL)

export const fetchEvaluateAction = createAction<any>(EVALUATE + FETCH)
export const fetchEvaluateDone = createAction<any>(EVALUATE + FETCH + DONE)
export const fetchEvaluateFail = createAction<any>(EVALUATE + FETCH + FAIL)
export const resetEvaluateAction = createAction(EVALUATE + RESET)

export const fetchTestResultsAction = createAction<any>(TEST_RESULTS + FETCH)
export const fetchTestResultsDone = createAction<any>(TEST_RESULTS + FETCH + DONE)
export const fetchTestResultsFail = createAction<any>(TEST_RESULTS + FETCH + FAIL)

export const fetchRegionsListAction = createAction<any>(REGIONS_LIST + FETCH)
export const fetchRegionsListDone = createAction<any>(REGIONS_LIST + FETCH + DONE)
export const fetchRegionsListFail = createAction<any>(REGIONS_LIST + FETCH + FAIL)

export const fetchDistrictsListAction = createAction<any>(DISTRICTS_LIST + FETCH)
export const fetchDistrictsListDone = createAction<any>(DISTRICTS_LIST + FETCH + DONE)
export const fetchDistrictsListFail = createAction<any>(DISTRICTS_LIST + FETCH + FAIL)

export const fetchCitiesListAction = createAction<any>(CITIES_LIST + FETCH)
export const fetchCitiesListDone = createAction<any>(CITIES_LIST + FETCH + DONE)
export const fetchCitiesListFail = createAction<any>(CITIES_LIST + FETCH + FAIL)

export const fetchListRequestAction = createAction<any>(LIST_REQUEST + FETCH)
export const fetchListRequestDone = createAction<any>(LIST_REQUEST + FETCH + DONE)
export const fetchListRequestFail = createAction<any>(LIST_REQUEST + FETCH + FAIL)

export const fetchCreateApplicationAction = createAction<any>(CREATE_APPLICATION + FETCH)
export const fetchCreateApplicationDone = createAction<any>(CREATE_APPLICATION + FETCH + DONE)
export const fetchCreateApplicationFail = createAction<any>(CREATE_APPLICATION + FETCH + FAIL)

export const fetchSetLikeAction = createAction<any>(SET_LIKE + FETCH)
export const fetchSetLikeDone = createAction<any>(SET_LIKE + FETCH + DONE)
export const fetchSetLikeFail = createAction<any>(SET_LIKE + FETCH + FAIL)

export const fetchContentByCategoryAction = createAction<any>(CONTENT_BY_CATEGORY + FETCH)
export const fetchContentByCategoryDone = createAction<any>(CONTENT_BY_CATEGORY + FETCH + DONE)
export const fetchContentByCategoryFail = createAction<any>(CONTENT_BY_CATEGORY + FETCH + FAIL)

export const fetchMarathonWeeksAction = createAction<any>(FETCH_MARATHON_WEEKS + FETCH)
export const fetchMarathonWeeksActionDone = createAction<any>(FETCH_MARATHON_WEEKS + FETCH + DONE)
export const fetchMarathonWeeksActionFail = createAction<any>(FETCH_MARATHON_WEEKS + FETCH + FAIL)

export const fetchMarathonDaysAction = createAction<any>(FETCH_MARATHON_DAYS + FETCH)
export const fetchMarathonDaysActionDone = createAction<any>(FETCH_MARATHON_DAYS + FETCH + DONE)
export const fetchMarathonDaysActionFail = createAction<any>(FETCH_MARATHON_DAYS + FETCH + FAIL)

export const fetchMarathonTasksAction = createAction<any>(FETCH_MARATHON_TASKS + FETCH)
export const fetchMarathonTasksActionDone = createAction<any>(FETCH_MARATHON_TASKS + FETCH + DONE)
export const fetchMarathonTasksActionFail = createAction<any>(FETCH_MARATHON_TASKS + FETCH + FAIL)

export const fetchMarathonTaskAction = createAction<any>(FETCH_MARATHON_TASK + FETCH)
export const fetchMarathonTaskActionDone = createAction<any>(FETCH_MARATHON_TASK + FETCH + DONE)
export const fetchMarathonTaskActionFail = createAction<any>(FETCH_MARATHON_TASK + FETCH + FAIL)

export const saveDiaryAction = createAction<any>(SAVE_DIARY + FETCH)
export const saveDiaryActionDone = createAction<any>(SAVE_DIARY + FETCH + DONE)
export const saveDiaryActionFail = createAction<any>(SAVE_DIARY + FETCH + FAIL)

export const fetchDiaryAction = createAction<any>(FETCH_DIARY + FETCH)
export const fetchDiaryActionDone = createAction<any>(FETCH_DIARY + FETCH + DONE)
export const fetchDiaryActionFail = createAction<any>(FETCH_DIARY + FETCH + FAIL)

export const fetchDiaryTableAction = createAction<any>(FETCH_DIARY_TABLE + FETCH)
export const fetchDiaryTableActionDone = createAction<any>(FETCH_DIARY_TABLE + FETCH + DONE)
export const fetchDiaryTableActionFail = createAction<any>(FETCH_DIARY_TABLE + FETCH + FAIL)

export const taskCompleteAction = createAction<any>(TASK_COMPLETE + FETCH)
export const taskCompleteActionDone = createAction<any>(TASK_COMPLETE + FETCH + DONE)
export const taskCompleteActionFail = createAction<any>(TASK_COMPLETE + FETCH + FAIL)

export const setDiagnosticResult = createAction<any>(SET + DIAGNOSTIC_RESULT)
export const resetCreateApplicationAction = createAction<any>(RESET + CREATE_APPLICATION)

export const setSelectedChildId = createAction<any>(SET + SELECTED_CHILD_ID)

export const setTaskCompletedLocal = createAction<{ dayId: number; taskId: number; completed: boolean }>(SET + TASK_COMPLETED_LOCAL)
